import { flatCheckboxGroupsToItems } from '../../../helpers/flatCheckboxGroupsToItems';
import { CheckboxGroupsItemChangeModelLazy } from '../../../models/CheckboxGroupsItemChangeModel';
export function prepareMultiplyCheckboxGroupsItemChangeModel(groups, checkboxGroupItemChangeModel) {
  var calcAllItems = function calcAllItems() {
    var allValuesCollection = new Set(checkboxGroupItemChangeModel.checkboxGroupChangeModel.allValues);
    return flatCheckboxGroupsToItems(groups).filter(function (item) {
      return allValuesCollection.has(item.value);
    });
  };

  return new CheckboxGroupsItemChangeModelLazy(checkboxGroupItemChangeModel, calcAllItems);
}